<template>
  <!-- jedan blok dogadjaja za sve slucajeve (TopEvent, TopEventNoImage i TopEventOther su tanki omotaci oko ovoga) -->
  <BlockCard
    :title="title"
    :title-to="titleTo"
    :dropdown-items="dropdown ? dropdownItems : []"
    :more-to="showAll ? titleTo : null"
    :more-class="layout === 'feed' ? 'text-primary' : 'text-muted'"
    height="event"
  >
    <!-- feed: vreme malim slovima iznad podebljanog naslova, sa linijom levo (Kalendar stocnih pijaca) -->
    <template v-if="layout === 'feed'">
      <hr class="mt-0" />
      <ol class="activity-feed mb-0 ps-2">
        <EventFeedItem v-for="event in visibleItems" :key="event.id" :event="event" />
      </ol>
    </template>

    <template v-else>
      <EventRow
        v-for="event in visibleItems"
        :key="event.id"
        :event="event"
        :show-image="showImage"
        :show-place="showPlace"
      />
    </template>
  </BlockCard>
</template>

<script setup>
import BlockCard from '~/components/widgets/BlockCard.vue'
import EventRow from '~/components/cms/event/Display/EventRow.vue'
import EventFeedItem from '~/components/cms/event/Display/EventFeedItem.vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  // vidi composables/useItemFilter.ts, npr. { top_event: true } ili { top_event: false, category_name: 'Koncerti' }
  filter: { type: Object, default: () => ({}) },
  // opseg iz filtrirane liste: offset od kog, najvise limit (0 = do kraja)
  offset: { type: Number, default: 0 },
  limit: { type: Number, default: 0 },
  title: { type: String, default: '' },
  // kategorija na koju vodi naslov; bez nje naslov vodi na sve dogadjaje meseca
  category: { type: String, default: '' },
  year: { type: Number, default: undefined },
  month: { type: String, default: '' },
  // 'rows': red sa slikom ili bez (kao oglasi); 'feed': vreme iznad naslova
  layout: { type: String, default: 'rows' },
  showImage: { type: Boolean, default: true },
  showPlace: { type: Boolean, default: true },
  // padajuca lista kategorija u gornjem uglu: 'category' | '' (bez liste)
  dropdown: { type: String, default: '' },
  // umesto liste: link "Pogledaj sve" ka naslovu
  showAll: { type: Boolean, default: false },
})

const routePath = useRoutePath()
const { $srbTolat } = useNuxtApp()
const { uniqValuesByKey } = useCollectionUtils()

const filtered = computed(() => filterByFields(props.items, props.filter))

const visibleItems = computed(() =>
  filtered.value.slice(props.offset, props.limit > 0 ? props.offset + props.limit : undefined)
)

const monthSlug = computed(() => (props.month || '').toLowerCase())

const categoryLink = (name) => routePath({
  name: 'kalendar-dogadjaja-event-kategorija-year-month-page',
  params: { event: $srbTolat.srbTolat(name), year: props.year, month: monthSlug.value, page: 1 },
})

const titleTo = computed(() =>
  props.category
    ? categoryLink(props.category)
    : routePath({
        name: 'kalendar-dogadjaja-dogadjaji-year-month-page',
        params: { year: props.year, month: monthSlug.value, page: 1 },
      })
)

const dropdownItems = computed(() =>
  props.dropdown === 'category'
    ? uniqValuesByKey(filtered.value, 'category_name').map((name) => ({ key: name, label: name, to: categoryLink(name) }))
    : []
)
</script>
